import { render, staticRenderFns } from "./LessonPreparation.vue?vue&type=template&id=33825b56&scoped=true&"
import script from "./LessonPreparation.vue?vue&type=script&lang=js&"
export * from "./LessonPreparation.vue?vue&type=script&lang=js&"
import style0 from "./LessonPreparation.vue?vue&type=style&index=0&id=33825b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33825b56",
  null
  
)

export default component.exports